export default () => {
  (function($) {
    function relocateButton() {
      if ($(window).scrollTop() - $('.goToTop').position().top + $(window).height() >= $(window).height() * 0.1) {
        $('.goToTop__button').attr('style', '').css({
          position: 'static'
        })
      } else {
        $('.goToTop__button').attr('style', '').css({
          position: 'fixed',
          marginLeft: $('.goToTop').width() / 2,
          left: '50%',
          right: 'auto',
          transform: 'translateX(-100%)'
        })
      }
    }
    $(document).ready(function() {
      if ($('.goToTop').length) {
        $('.goToTop').on('click', function() {
          $('html, body').animate(
            {
              scrollTop:0
            }, 500, function() {
              $('#page').focus()
            });
        })
      }
    })
  })(window.hsvmJQuery)
}